import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NowhowDatepicker',
  props: {
    disabled: { type: Boolean, default: false },
    modelValue: { type: String, default: '' },
    label: { type: String, default: '' },
    errorMessages: { type: Array<string>, default: () => [] },
    error: { type: Boolean, default: false }
},
  emits: ['update:modelValue', 'change', 'blur'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const menu = ref(false);
const isoDate = ref<Date | null>(null);
const textValue = ref(props.modelValue);
const touched = ref(false);

// VeeValidate Kompatibilität
const fieldProps = computed(() => ({
    onBlur: handleBlur,
    onInput: handleInput
}));

const hasError = computed(() => {
    return props.error || (touched.value && props.errorMessages.length > 0);
});

watch(
    () => props.modelValue,
    (newVal) => {
        textValue.value = newVal;
        if (!newVal) {
            isoDate.value = null;
        }
    }
);

const handleInput = () => {
    touched.value = true;
};

const handleBlur = () => {
    touched.value = true;
    emit('blur');
    labelChanged();
};

const updateDate = (newDate: Date | null) => {
    isoDate.value = newDate;
    touched.value = true;

    if (newDate) {
        const formatted = newDate.toLocaleDateString('de-CH', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
        textValue.value = formatted;
        emit('update:modelValue', formatted);
        emit('change', formatted);
    } else {
        textValue.value = '';
        emit('update:modelValue', '');
        emit('change', '');
    }

    menu.value = false;
};

const labelChanged = () => {
    const raw = textValue.value?.trim() ?? '';
    if (!raw) {
        isoDate.value = null;
        textValue.value = '';
        emit('update:modelValue', '');
        emit('change', '');
        return;
    }

    const parts = raw.split('.');
    if (parts.length === 3) {
        const [dayStr, monthStr, yearStr] = parts.map((p) => p.trim());
        const day = parseInt(dayStr, 10);
        const month = parseInt(monthStr, 10);
        const year = parseInt(yearStr, 10);

        const newDate = new Date(year, month - 1, day);
        if (!isNaN(newDate.getTime()) && newDate.getFullYear() === year && newDate.getMonth() === month - 1 && newDate.getDate() === day) {
            const formatted = newDate.toLocaleDateString('de-CH', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            isoDate.value = newDate;
            textValue.value = formatted;
            emit('update:modelValue', formatted);
            emit('change', formatted);
            return;
        }
    }

    // Invalid input → reset
    isoDate.value = null;
    textValue.value = '';
    emit('update:modelValue', '');
    emit('change', '');
};

const setDateToday = () => {
    updateDate(new Date());
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_menu, {
      modelValue: menu.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menu).value = $event)),
      "close-on-content-click": false,
      "nudge-right": 40,
      disabled: __props.disabled,
      transition: "scale-transition",
      "allow-overflow": true,
      "offset-y": ""
    }, {
      activator: _withCtx(({ props: activatorProps }) => [
        _createVNode(_component_v_text_field, _mergeProps({ ...activatorProps, ...fieldProps.value }, {
          modelValue: textValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textValue).value = $event)),
          label: __props.label,
          "persistent-hint": "",
          "prepend-icon": "mdi-calendar",
          variant: "outlined",
          density: "comfortable",
          disabled: __props.disabled,
          error: hasError.value,
          "error-messages": __props.errorMessages,
          onBlur: handleBlur,
          onInput: handleInput
        }), null, 16, ["modelValue", "label", "disabled", "error", "error-messages"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_locale_provider, { locale: "de" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker, {
              modelValue: isoDate.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((isoDate).value = $event)),
                updateDate
              ],
              class: "elevation-4",
              "show-current": "",
              header: "keepThisToRemoveTranslationWarning",
              "hide-header": ""
            }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  size: "small",
                  onClick: setDateToday
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('heute')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"])
  ]))
}
}

})